var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppointmentStatusesAsOptions } from 'constants/appointmentStatus';
import { useFormContext } from 'react-hook-form';
import { DependentAdult } from 'shared/assets/icons';
import { Box, Flex, FormControl, FormSelect, Icon } from 'shared/components';
export var AppointmentStatus = function (_a) {
    var readOnly = _a.readOnly;
    var register = useFormContext().register;
    return (_jsx(FormControl, __assign({ mr: 2, isRequired: true }, { children: _jsxs(Flex, __assign({ direction: "row" }, { children: [_jsx(Box, __assign({ mr: 2 }, { children: _jsx(Icon, { as: DependentAdult, boxSize: 4 }) })), _jsx(FormSelect, { "data-testid": "selectAppointmentStatus", name: "sessionInfo.status", options: AppointmentStatusesAsOptions, isReadOnly: readOnly, register: register, variant: "unstyled" })] })) })));
};
